module.exports = __webpack_public_path__ + "img/dsci0048.c9a6af94.jpg";